import styled from 'styled-components';
import media from 'src/styles/Media.styled.js';
import { astriskStyle } from 'src/styles/CommonStyles.styled';

export const SelectBiologics = styled.span`
    font-family: 'AvenirNextWorld Italic';
    ${media.extraLarge`
    width: 181px;
    height: 24px;
    text-align: left;
    letter-spacing: -0.11px;
    color: #140f4b;
    opacity: 1;
    margin-bottom: 12.98px;
`}
    ${media.smalDevice`
width: 181px;
height: 24px;
text-align: left;
letter-spacing: -0.11px;
color: #140f4b;
opacity: 1;
margin-bottom: 12.98px;
`}
${media.mobileDevice`
width: 181px;
height: 24px;
text-align: left;
font-size: 14px;
letter-spacing: -0.11px;
color: #140f4b;
opacity: 1;
margin-bottom: 12.98px;
`}
    ${astriskStyle};
`;

export const BiologyContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
`;

export const TableHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    width: ${({ width }) => (width ? width : '100%')};
    background: #e8e8e8 0% 0% no-repeat padding-box;
    opacity: 0.5;
`;
export const CheckRowDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    ${astriskStyle};
`;

export const BiologicsDetailsheaderwrapper = styled.div`
    @media only screen and (max-device-width: 360px) {
        font-size: 11px !important;
    }
`;
